export default __webpack_public_path__ + "static/media/saint-cloudmini.1d6eff00.jpg";